import React, { useEffect } from 'react'
import { Container } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import setMetaTags from '../component/MetaTag'
import { defaultTag } from '../model'

const Home = () => {
    useEffect(() => {
        setMetaTags(defaultTag)
        return () => {
            setMetaTags({})
        }
    })
    return (
        <div className='bloc l-bloc' id='bloc-0'>
            <Container className='block-lg'>
                <div className='row'>
                    <div className='col'>
                        <ul className='list-unstyled list-sp-md'>
                            <li>========앱연결 단일 페이지======</li>
                            <li><Link
                                to='/coupons/delivery/confirm/ok?q=JDJhJDEwJC52clQvUkZSVDFVMlpTRGx0ZjZBWU9FNGpQRWQ1ZFg2aDdPSHZwZlozNDVXTFkxQUVNTVlL'
                                className='a-btn a-block'>배달접수 완료시</Link></li>
                            <li><Link
                                to='/coupons/delivery/confirm/reject?q=JDJhJDEwJC52clQvUkZSVDFVMlpTRGx0ZjZBWU9FNGpQRWQ1ZFg2aDdPSHZwZlozNDVXTFkxQUVNTVlL'
                                href='' className='a-btn a-block'>배달 불가시</Link></li>
                            <li><Link to='/404' className='a-btn a-block'>Not Found Page</Link></li>
                            <li><Link to='/postcode' className='a-btn a-block'>우편번호찾기</Link></li>
                            <li><Link to='/coupons/tour/certification' className='a-btn a-block'>투어인증서쿠폰</Link></li>
                            <li>========앱/웹 연결 페이지======</li>
                            <li><Link to='/company/introduction' className='a-btn a-block'>더보기/도입요청</Link></li>
                            <li><Link to='/company/introduction?theme=dark'
                                      className='a-btn a-block'>더보기/도입요청(블랙)</Link></li>
                            <li><Link to='/boards' className='a-btn a-block'>더보기/ 공지사항</Link></li>
                            <li><Link to='/boards?theme=dark' className='a-btn a-block'>더보기/공지사항(블랙)</Link></li>
                            <li><Link to='/boards/qna' className='a-btn a-block'>더보기/고객센터/문의하기</Link></li>
                            <li><Link to='/boards/qna?theme=dark' className='a-btn a-block'>더보기/고객센터/문의하기(블랙)</Link>
                            </li>
                            <li><Link to='/boards/help' className='a-btn a-block'>더보기/고객센터/도움말</Link></li>
                            <li><Link to='/boards/qhelp?theme=dark' className='a-btn a-block'>더보기/고객센터/도움말(블랙)</Link>
                            </li>
                            <li><Link to='/terms' className='a-btn a-block'>더보기/고객센터/이용약관1</Link></li>
                            <li><Link to='/terms?black' className='a-btn a-block'>더보기/고객센터/이용약관1(블랙)</Link></li>
                            <li><Link to='/terms/location' className='a-btn a-block'>더보기/고객센터/이용약관2</Link></li>
                            <li><Link to='/terms/location?theme=dark'
                                      className='a-btn a-block'>더보기/고객센터/이용약관2(블랙)</Link></li>
                            <li><Link to='/terms/private' className='a-btn a-block'>더보기/ 고객센터/이용약관3</Link></li>
                            <li><Link to='/terms/private?theme=dark' className='a-btn a-block'>더보기/고객센터/이용약관3(블랙)</Link>
                            </li>
                            <li><Link to='/terms/serviceen' className='a-btn a-block'>더보기/고객센터/이용약관(영문)</Link></li>
                            <li><Link to='/boards/global' className='a-btn a-block'>해외 점주용 공지사항</Link></li>
                            <li><Link to='/members/withdrawal' className='a-btn a-block'>회원탈퇴요청</Link></li>
                            <li><Link to='/members/withdrawal?lang=en' className='a-btn a-block'>회원탈퇴요청(영문)</Link></li>
                            <li>========애플로그인======</li>
                            <li><Link to='/apple/login' className='a-btn a-block'>애플로그인</Link></li>
                            <li><Link to='/apple/playq/login' className='a-btn a-block'>애플(playq)로그인</Link></li>
                            <li><Link
                                to='/url#url=/boards/qna?theme=dark&token=eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiIxNzkyMzkiLCJyb2xlcyI6W10sInVzZXJEYXRhIjoie1wibG9naW5JZFwiOlwiYW5vbnltb3VzXCIsXCJuYW1lXCI6XCJLYWthb0AxMzc4Mjg1OTExMlwiLFwibWVtYmVyVHlwZVwiOlwiS2FrYW9cIixcInNzb0tleVwiOlwiYW5vbnltb3VzXCJ9IiwiaWF0IjoxNjc1MDY2MjQ5LCJleHAiOjE3MDY2MDIyNDl9.jAwbfFaEOxHy6XCWZMI55YnkbkXahsuBheCg8RXpCwDxZWpMKgEnh0vnQBFRjr3ZR_RCfl6bwz_09g2gZlVwEQ'
                                className='a-btn a-block'>이동하기(고객센터)</Link></li>

                            {/*<li>======== 점주용 페이지 ========</li>*/}

                        </ul>

                        {/*<li>========Degign Coding Page======</li>*/}
                        {/*<li><Link to="/company" className="a-btn a-block">회사소개</Link></li>*/}
                        {/*<li><Link to="/company/about" className="a-btn a-block">About us</Link></li>*/}
                        {/*<li><a href="introduction.html" className="a-btn a-block">더보기/ 도입요청</a></li>
                            <li><a href="notice.html" className="a-btn a-block">더보기/ 공지사항</a></li>
                            <li><a href="help.html" className="a-btn a-block">더보기/ 고객센터/ 도움말</a></li>
                            <li><a href="help_menu.html" className="a-btn a-block">더보기/ 고객센터/ 도움말/ 카테고리</a></li>
                            <li><a href="contents_read.html" className="a-btn a-block">더보기/ 고객센터/ 도움말/ 본문</a></li>
                            <li><a href="help_search.html" className="a-btn a-block">더보기/ 고객센터/ 도움말/ 검색결과</a></li>
                            <li><a href="question.html" className="a-btn a-block">더보기/ 고객센터/ 문의하기</a></li>
                            <li><a href="question_write.html" className="a-btn a-block">더보기/ 고객센터/ 문의하기/ 쓰기</a></li>
                            <li><a href="service_01.html" className="a-btn a-block">더보기/ 고객센터/ 이용약관1</a></li>
                            <li><a href="service_02.html" className="a-btn a-block">더보기/ 고객센터/ 이용약관2</a></li>
                            <li><a href="service_03.html" className="a-btn a-block">더보기/ 고객센터/ 이용약관3</a></li>*/}
                    </div>
                </div>
            </Container>
        </div>
    )
}

export default Home
